import { render, staticRenderFns } from "./variety.vue?vue&type=template&id=33ff8fd6&scoped=true&"
import script from "./variety.vue?vue&type=script&lang=js&"
export * from "./variety.vue?vue&type=script&lang=js&"
import style0 from "./variety.vue?vue&type=style&index=0&id=33ff8fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ff8fd6",
  null
  
)

export default component.exports